import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { learningSubNav } from "@/lib/navigationItems";
import { usePermissions } from "@/hooks/usePermissions";

export const Route = createFileRoute("/portal/lms")({
  component: LmsLayout,
});

/**
 * LMS management layout (`/portal/lms`) — curation, authoring, assignment,
 * cycles and leaderboards. Gated exactly like `/portal/learning`: on the `lms`
 * RBAC resource alone, so an organisation's own curators and managers reach it
 * (Supernova self-serves; no `user.is_admin` check). Both layouts render the
 * one Learning tab strip (`learningSubNav`): it is one product with one sidebar
 * item, whose pages happen to live under two route prefixes.
 *
 * The render is held while RBAC is resolving, because `can()` answers false
 * until then and would bounce a permitted user. Visibility is all this guard
 * decides: each page shows what the caller may act on, and dp lms enforces
 * every route (per-category curator gate, per-team board gate).
 */
function LmsLayout() {
  const { can, rbacResolving } = usePermissions();
  const navigate = useNavigate();
  const canView = can("view", "lms");

  useEffect(() => {
    if (!rbacResolving && !canView) {
      navigate({ to: "/portal" });
    }
  }, [rbacResolving, canView, navigate]);

  if (rbacResolving || !canView) {
    return null;
  }

  return (
    <div className="space-y-4">
      <ProductSubNav items={learningSubNav} />
      <Outlet />
    </div>
  );
}
